import { render, staticRenderFns } from "./DraftedChecklist.vue?vue&type=template&id=0cc40981"
import script from "./DraftedChecklist.vue?vue&type=script&lang=js"
export * from "./DraftedChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports